import { showSuccess, showError, showWarning, showInfo, showSnackbar } from '../utils/snackbarUtils';

/**
 * A service class that demonstrates how to use the snackbar utility from non-React code.
 * This can be used in services, utilities, or any other non-React code.
 */
class SnackbarService {
  /**
   * Show a success notification
   * @param {string} message - The message to display
   * @param {number} duration - How long to display the notification (in milliseconds)
   */
  static showSuccess(message, duration) {
    showSuccess(message, duration);
  }

  /**
   * Show an error notification
   * @param {string} message - The message to display
   * @param {number} duration - How long to display the notification (in milliseconds)
   */
  static showError(message, duration) {
    showError(message, duration);
  }

  /**
   * Show a warning notification
   * @param {string} message - The message to display
   * @param {number} duration - How long to display the notification (in milliseconds)
   */
  static showWarning(message, duration) {
    showWarning(message, duration);
  }

  /**
   * Show an info notification
   * @param {string} message - The message to display
   * @param {number} duration - How long to display the notification (in milliseconds)
   */
  static showInfo(message, duration) {
    showInfo(message, duration);
  }

  /**
   * Show a notification with the specified type
   * @param {string} message - The message to display
   * @param {string} type - The type of notification ('success', 'error', 'warning', 'info')
   * @param {number} duration - How long to display the notification (in milliseconds)
   */
  static showNotification(message, type, duration) {
    showSnackbar(message, type, duration);
  }

  /**
   * Example method that demonstrates how to use the snackbar in a service method
   * @param {string} operation - The operation being performed
   * @returns {Promise<boolean>} - Whether the operation was successful
   */
  static async performOperation(operation) {
    try {
      // Simulate an API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Show success notification
      this.showSuccess(`${operation} completed successfully!`);
      
      return true;
    } catch (error) {
      // Show error notification
      this.showError(`${operation} failed: ${error.message}`);
      
      return false;
    }
  }
}

export default SnackbarService; 